/**
 * tccf7Back クラス
 * - 「戻る」ボタンの初期化とクリックイベント処理を管理
 */
export default class tccf7Back {
  /**
   * @param {HTMLElement} elem - 対象フォーム要素のラッパー
   * @param {Object} btn - ボタンに関するクラス名（back, backWrap）
   */
  constructor(elem, btn) {
    this.elem           = elem;
    this.backBtnClass   = btn.back;
    this.backWrapClass  = btn.backWrap;

    this.backBtn        = null; // 戻るボタン要素
    this.backBtnWrap    = null; // ラップ要素
    this.bound          = null; // bind 済みの click 関数

    this.setCallback     = null; // 初期化時コールバック
    this.clickCallback   = null; // クリック時コールバック
    this.updateCallback  = null; // 更新時コールバック
  }

  /**
   * 初期化処理（ページ読み込み時など）
   * @param {(wrapEl: HTMLElement|null) => void} callback - 初期処理用コールバック
   */
  init(callback) {
    this.set();
    this.setClick();

    this.setCallback = callback;
    if (typeof this.setCallback === 'function') {
      this.setCallback(this.backBtnWrap);
    }
  }

  /**
   * 再バインドや動的更新用処理
   * @param {(wrapEl: HTMLElement|null) => void} updateCallback - 更新用コールバック
   * @param {(wrapEl: HTMLElement|null) => void} clickCallback - クリック時の処理
   */
  update(updateCallback, clickCallback) {
    this.updateCallback = updateCallback;
    this.clickCallback  = clickCallback;

    this.set();
    this.setClick();

    if (typeof this.updateCallback === 'function') {
      this.updateCallback(this.backBtnWrap);
    }
  }

  /**
   * ボタン・ラップ要素の取得
   */
  set() {
    this.backBtn     = this.elem.querySelector(this.backBtnClass) || null;
    this.backBtnWrap = this.elem.querySelector(this.backWrapClass) || null;
  }

  /**
   * クリックイベントの設定（重複登録防止含む）
   */
  setClick() {
    if (this.backBtn !== null) {
      if (!this.bound) {
        this.bound = this.click.bind(this);
      }
      this.backBtn.removeEventListener('click', this.bound);
      this.backBtn.addEventListener('click', this.bound);
    }
  }

  /**
   * 「戻る」ボタンのクリック時処理
   */
  click() {
    if (typeof this.clickCallback === 'function') {
      this.clickCallback(this.backBtnWrap);
    }
  }
}
